import { travelerForm } from '@eti/travelers';
import { string } from '@eti/utils';
import { composeValidators, isRequired, isValidTaxId } from '@eti/validation';

const validationRules = (taxIdData: {
  taxIdFieldLabel: string;
  taxIdFieldFormat: string;
  taxIdRequired: string;
  invalidTaxId: string;
}) => {
  const { taxIdRequired, invalidTaxId, taxIdFieldLabel, taxIdFieldFormat } = taxIdData;
  const taxIdRequiredMessage =
    taxIdFieldLabel && taxIdRequired
      ? string.insertArgument(taxIdRequired, taxIdFieldLabel)
      : 'tax ID field is Required';
  const invalidTaxIdMessage =
    taxIdFieldLabel && invalidTaxId
      ? string.insertArgument(invalidTaxId, taxIdFieldLabel)
      : 'invalid format for tax ID';
  return {
    [travelerForm.TAX_ID_INPUT]: composeValidators(
      isRequired({ message: taxIdRequiredMessage }),
      isValidTaxId(taxIdFieldFormat)({ message: invalidTaxIdMessage }),
    )(travelerForm.TAX_ID_INPUT),
  };
};

export default validationRules;
